var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"table-row-actions"},[_c('span',{staticClass:"table-row-actions__item"},[_vm._t("view")],2),_c('span',{staticClass:"table-row-actions__item"},[_vm._t("edit")],2),(_vm.showDelete)?_c('span',{staticClass:"table-row-actions__item"},[_vm._t("delete")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }